<footer
  class="footer bg-footerBackgroud flex items-center justify-end px-[clamp(0.5rem,0.04rem+0.96vw,1rem)]">
  <span
    class="text-white text-[clamp(0.75rem,0.564rem+0.388vw,1rem)] leading-none"
    >Valley Check Pivot &copy; {{ currentYear }}</span
  >
</footer>
